import React from 'react'

import * as styles from 'common/builder/components/chart/FlowChart/components/Block/generic/QuickReplies/QuickReplies.styles'
import { BlockComponent } from 'common/builder/components/chart/FlowChart/components/Block/types'
import { QuickReplyButton } from 'common/builder/components/chart/FlowChart/components/QuickReplyButton/QuickReplyButton'
import { FlowChartQuickRepliesBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartQuickRepliesBlock'

export const QuickReplies: BlockComponent<FlowChartQuickRepliesBlock> = ({ block }) => {
  if (block.data.buttons.length === 0) {
    return null
  }

  return (
    <view style={styles.List}>
      {block.data.buttons.map((button, index) => (
        <QuickReplyButton
          button={button}
          key={button.id}
          style={index !== 0 ? styles.ButtonWithMargin : undefined}
        />
      ))}
    </view>
  )
}
